// メッセージMap
export const MessageMap = {
    "user": "ログインID",
    "password": "パスワード",
};
